import React from "react";
import { Modal } from "react-bootstrap";
import styles from "./ViewNotes.module.scss";
import { FaRegTimesCircle } from "react-icons/fa";
import moment from "moment";

const AnomaliesViewNotes = ({
  onClose,
  notes,
}: {
  onClose: CallableFunction;
  notes: any[];
}) => {
  return (
    <Modal show={true} className={styles.viewNotesModal}>
      <Modal.Header>
        <Modal.Title>
          <span className="fs-24 fw-700 text-grey-900">Notes</span>
        </Modal.Title>
        <FaRegTimesCircle
          size={28}
          className="cursor-pointer"
          onClick={() => {
            onClose();
          }}
        />
      </Modal.Header>
      <Modal.Body>
        <div className="p-4">
          {notes?.map((item: any, index: number) => (
            <div className="card mb-3" key={`coach-note-${index}`}>
              <div className="card-body">
                <h6 className="card-title fs-18 fw-600 mb-1 d-flex align-items-center justify-content-between">
                  <span>{item?.trainerDetails?.trainerName}</span>
                  <span className="fs-14">
                    {moment(item?.createdAt).format("DD MMM YYYY, hh:mm a")}
                  </span>
                </h6>
                <p className="card-text">{item?.text}</p>
              </div>
            </div>
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AnomaliesViewNotes;
